/**
 * Converts count object to pie chart data format.
 * @param {Object<string, number>} counts
 * @param {Object} [options]
 * @param {Object<string, string>} [options.labelMap]
 * @param {'value'|'label'|'state'} [options.sortBy]
 * @param {string[]} [options.stateOrder] - required when sortBy === 'state'
 * @returns {Array<{id: string, value: number, label: string}>}
 */
export function toPieData(counts, options = {}) {
  const { labelMap = {}, sortBy = "value", stateOrder = [] } = options;
  const entries = Object.entries(counts).map(([key, value]) => ({
    id: key,
    value,
    label: labelMap[key] ?? key,
  }));

  if (sortBy === "label") {
    entries.sort((a, b) => a.label.localeCompare(b.label));
  } else if (sortBy === "state") {
    entries.sort((a, b) => {
      const idxA = stateOrder.indexOf(a.id);
      const idxB = stateOrder.indexOf(b.id);
      if (idxA === -1 && idxB === -1) return a.label.localeCompare(b.label);
      if (idxA === -1) return 1;
      if (idxB === -1) return -1;
      return idxA - idxB;
    });
  } else {
    entries.sort((a, b) => b.value - a.value);
  }

  return entries;
}
